import { useEffect } from 'react';

import canUseDOM from '../util/can-use-dom';

/**
 * Conditionally add or remove a body class.
 *
 * @param {string} className The class name.
 * @param {boolean} condition The condition - true adds the class, false removes it.
 */
const useBodyClass = (className, condition) => {
  useEffect(() => {
    if (!canUseDOM) {
      return;
    }

    if (condition) {
      document.body.classList.add(className);
    } else {
      document.body.classList.remove(className);
    }
  }, [condition]);
};

export default useBodyClass;
